import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    fetchMore: 'See more',
    searchbar: 'Search by client...',
  },
  fr: {
    fetchMore: 'Voir plus',
    searchbar: 'Recherche par client·e...',
  },
} as const);

export default locales;
